
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { ProfileSection } from "./ProfileSection";
import { IntroductionSection } from "./IntroductionSection";
import { CarouselSection } from "./CarouselSection";
import { ThemeBackground } from "./ThemeBackground";
import { DEFAULT_THEME_ID } from "@/data/heroThemes";

interface HeroSectionProps {
  heroType?: string | null;
  themeId?: string | null;
}

export const HeroSection = ({ heroType, themeId }: HeroSectionProps) => {
  const [showProfileImage, setShowProfileImage] = useState(false);
  const { id } = useParams();
  
  // Show theme background when heroType is 'theme' (use default theme if themeId not set)
  const showTheme = heroType === 'theme';
  const effectiveThemeId = themeId || DEFAULT_THEME_ID;
  
  return (
    <section className="relative min-h-[50vh] md:min-h-[60vh] lg:min-h-[70vh]">
      {/* Background - theme or carousel */}
      <div className="absolute inset-x-0 top-0 h-[50vh] md:h-[60vh] lg:h-[70vh] overflow-hidden flex items-center justify-center">
        {showTheme ? (
          <ThemeBackground themeId={effectiveThemeId} className="w-full md:w-[85%] lg:w-[75%] xl:w-[70%] h-full mx-auto rounded-b-3xl" />
        ) : (
          <CarouselSection memorialId={id} />
        )}
      </div>

      {/* Content area - uses padding to position over carousel, maintains document flow */}
      <div className="relative z-10 pt-[10vh] md:pt-[25vh] lg:pt-[30vh]">
        <div className="flex flex-col items-center w-full">
          <ProfileSection showProfileImage={showProfileImage} setShowProfileImage={setShowProfileImage} />
          <IntroductionSection />
        </div>
      </div>
    </section>
  );
};
